import { render, staticRenderFns } from "./RflmBackground.vue?vue&type=template&id=981d52aa"
import script from "./RflmBackground.vue?vue&type=script&lang=ts"
export * from "./RflmBackground.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports